import React from 'react';

import classnames from 'classnames';
import { prop } from 'ramda';

import styles from './index.module.css';

const TITLE_ELE_LIST = [1, 2, 3, 4, 5];

const defaultProps = {
  level: 1,
};

const getComponent = (level) => {
  if (level && TITLE_ELE_LIST.indexOf(level) !== -1) {
    return `h${level}`;
  } else {
    //console.warn('Title accept only `1 | 2 | 3 | 4 | 5` as `level` value.');
    return 'h1';
  }
};

const Title = ({ children, level, noMargin, weight, italic, noTransform, className, ...rest }) => {
  const classname = classnames(
    prop(`h${level}`, styles),
    noMargin && styles.noMargin,
    prop(`weight-${weight}`, styles),
    italic && styles.italic,
    noTransform && styles.textTransformNormal,
    className,
  );

  const Component = getComponent(level);

  return (
    <Component className={classname} {...rest}>
      {children}
    </Component>
  );
};

Title.defaultProps = defaultProps;
export default Title;
